import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import BreadCrums from "../components/BreadCrums";
import TableComponent from "../components/TableComponent";
import { useDispatch, useSelector } from "react-redux";
import { getAllPlans, getPlanHistory } from "../redux/actions/dashBoardActions";
import Loader from "../components/Loader";
import Pagination from "../components/Pagination";
import { useLocation } from "react-router-dom";
import UpGradePlan from "../modals/UpGradePlan";
import { formatDate } from "../helpers/frontend";
import { getServiceType } from "../redux/actions/otherActions";
import InvoicePreview from "../modals/InvoicePreview";
import { ImagePath } from "../config/apiEndPoints";
import { callApi } from "../config/apiCall";
import { toast } from "react-toastify";
import NoData from "../components/NoData";

const CompanyPlansHistory = () => {
  const dispatch = useDispatch()
  const { state } = useLocation()
  const details = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const [modalData, setModalData] = useState({ isOpen: false, data: "" })
  const isLoading = useSelector((state) => state.commenData.loading)
  const planHistoryData = useSelector((state) => state.commenData?.planHistoryData)
  const [searchText, setSearchText] = useState("")
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    deliver: "",
    status: "",
    sort: "",
    currentPage: 1,
  })


  useEffect(() => {
    dispatch(getPlanHistory(state?.data))
    dispatch(getAllPlans(state?.data))
    dispatch(getServiceType())

  }, [])
  const UpcomingPlans = planHistoryData?.data?.plans?.find((item) => {
    return item?.status == "Upcoming"
  })

  const tableHeader = [
    "Invoice Number",
    "Service",
    "Subscription Plan",
    "Purchase Date",
    "Expiry Date",
    "Payment Status",
    "Due Date",
    "Plan Status",
    "Amount",
  ];

  const dataKeys = [
    "invoice",          // Company Name
    "services",          // Service Type (array stored as string)
    "plan_name",
    "start_date",
    "end_date",
    "payment_status",
    "due_date",
    "status",
    "total_price",
  ];


  const onClose = () => {
    setModalData((prev) => ({
      ...prev,
      type: "",
      isOpen: false,
    }))
  }
  const handleActions = (data, type) => {
    // //console.log(data, type);    
    if (type == "pdfDownload") {
      const url = `${ImagePath}${data?.invoice?.invoice_url}`;
      if (url) {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice${data?.end_date}.pdf`); // You can customize the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Invoice URL not found.");
      }
    } else {
      setModalData((prev) => ({
        ...prev,
        data: data,
        type: type,
        isOpen: true,
        onConfirm: "",
        onClose: onClose
      }))
    }
  }

  const handlePageChange = (page) => {
    // Call your API here to fetch data for the new page
    setFilters(prev => ({
      ...prev,
      currentPage: page,
      page: page
    }));
  };


  const changeFilter = (value, key) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value
    }))
  }

  const updateStatus = async (e) => {
    // //console.log("modalData" ,modalData);
    try {
      let response = await callApi(`/super-admin/payments/status/${modalData?.data?.invoice?.id}`, "POST", { status: e.target.value }, details?.token)
      // //console.log(response, "<<<<<<<<<Asdf");
      if (response.success) {
        toast.success(response?.message)
        dispatch(getPlanHistory(state?.data))
        onClose()
      }
    } catch (error) {
      if (error.response?.data?.message || error.message || "Server error") {
        toast.error(error.response?.data?.message || error.message || "Server error")
      }
      //console.log(error);
    }
  }


  return (
    <React.Fragment>
      <MainLayout>
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <BreadCrums
                title={"Company Plan History"}
                data={[
                  { path: "/superadmin/", title: "Superadmin" },
                  { path: "/superadmin/plans", title: "Plans" },
                  { path: "#", title: "Plan History" },
                ]}
              />
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="me-2 mb-2">

                </div>
                <div className="mb-2">
                  <a
                    onClick={() => {
                      setModalData((prev) => ({
                        ...prev,
                        isOpen: true,
                        type: "renew",
                        onClose: onClose
                      }))
                    }}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    Renew Plan
                  </a>
                </div>
                <div className="ms-2 head-icons"></div>
              </div>
            </div>

            {
              isLoading ?
                <Loader /> :
                <div className="card">
                  {
                    !isLoading && planHistoryData?.data?.plans?.length == 0 ? <NoData /> : <>
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="d-flex align-items-center gap-2">
                          <span className="avatar">
                            <img src={planHistoryData?.data?.company_logo ? ImagePath + planHistoryData?.data?.company_logo : "/assets/img/company/company-02.svg"} alt="logo" className="img-fluid rounded-circle border" />
                          </span>
                          <h5>{planHistoryData?.data?.company_name || ""} </h5>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                          {
                            UpcomingPlans && UpcomingPlans?.start_date &&
                            <div className="dropdown me-3">
                              <p className="d-flex gap-2 align-items-center">
                                <i className="ti ti-clock-hour-3 fs-16" />
                                Upcoming Plan:- {formatDate(UpcomingPlans?.start_date)}</p>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="row align-items-center px-3">
                        <div className="col-sm-12 col-md-6">
                          <div className="dataTables_length" >
                            <label>
                              Row per page
                              <select value={filters?.limit} onChange={(e) => {
                                changeFilter(e.target.value, "limit")
                              }} className="form-select form-select-sm">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                              Entries
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                          <div className="dataTables_filter m-0 text-end">
                            <label>
                              <input type="search"
                                className="form-control form-control-sm"
                                placeholder="Search"
                                value={searchText}
                                onChange={(e) => {
                                  setSearchText(e.target.value)
                                }}
                              />
                            </label></div>
                        </div>
                      </div>
                      <div className="card-body sv-card-body p-3">
                        <div className="custom-datatable-filter table-responsive">
                          <TableComponent
                            tableHeader={tableHeader}
                            dataSource={planHistoryData?.data?.plans?.filter((item) => {
                              if (searchText) {
                                return item.plan_name.toLowerCase().includes(searchText.toLowerCase())
                              }
                              return item
                            }) || []}
                            dataKeys={dataKeys || []}
                            onEdit={handleActions}
                            pdfDownload={handleActions}
                            pdfView={handleActions}
                            reminder={handleActions}
                          />
                        </div>
                      </div>
                    </>
                  }
                </div>
            }
            {
              planHistoryData?.data?.plans?.length == 0 ? "" :
                <Pagination pagination={planHistoryData?.pagination} onPageChange={handlePageChange} />
            }
          </div>

        </div>
      </MainLayout>

      {(modalData.type == "renew" || modalData.type == "upgrade") && modalData.isOpen &&
        <UpGradePlan handleData={{
          ...modalData,
          data: planHistoryData?.data
        }} />
      }
      {modalData.type == "pdfView" && modalData.isOpen &&
        <InvoicePreview handleData={modalData} companyData={planHistoryData?.data} />}

      {/* Edit Payment Status */}

      <div
        style={modalData?.isOpen && modalData.type == "edit" ? { display: "block" } : {}}
        className={`modal fade ${modalData?.isOpen && modalData.type == "edit" ? "show" : ""} `}
        id="edit_company" >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content shadow">
            <div className="modal-header">
              <h4 className="modal-title">Edit Payment Status </h4>
              <button type="button"
                className="btn-close custom-btn-close"
                onClick={() => {
                  onClose()
                }}>
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body pb-0 d-flex flex-column gap- ">
              <label className="d-flex gap-2 align-items-center pb-3">
                <input type="radio" value={"due"} name="status" onChange={(e) => { updateStatus(e) }} />
                Due
              </label>
              <label className="d-flex gap-2 align-items-center pb-3">
                <input type="radio" value={"overdue"} name="status" onChange={(e) => { updateStatus(e) }} />
                OverDue
              </label>
              <label className="d-flex gap-2 align-items-center pb-3">
                <input type="radio" value={"paid"} name="status" onChange={(e) => { updateStatus(e) }} />
                Paid
              </label>
              <label className="d-flex gap-2 align-items-center pb-3 ">
                <input type="radio" value={"unpaid"} name="status" onChange={(e) => { updateStatus(e) }} />
                Unpaid
              </label>
            </div>
            {/* <div className="modal-footer text-start">
              <button className="btn btn-primary">Update</button>
            </div> */}

          </div>
        </div>
      </div>


    </React.Fragment>
  );
};

export default CompanyPlansHistory;
